import styled from 'styled-components';
import { Menu, SelectionMenu } from '@pearsontechnology/aero-components';
import color from 'tinycolor2';

const {DropdownSelect } = SelectionMenu;


export const StyledDropDownSelect = styled(DropdownSelect)`
  display: flex;
  justify-content: space-between;
  padding-left: 5px;
  padding-right: 5px;
  width: 210px;
  height: 50px;
  margin-left: 30px;
  border: 5px;
  box-shadow: ${(props) => props.theme['shadow.card']};
  background: ${(props) => props.theme['color.background']};
  color: ${(props) => props.active ? props.theme['color.primary'] : props.theme['color.text.light']};
`;

export const SidebarWrapper = styled.div`
  display: flex;
  align-items: left;
  justify-content:center;
  flex-direction: column;
`;

export const IconLeft = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  color: ${(props) => props.active ? props.theme['color.primary'] : props.theme['color.text.light']};
`;

export const IconRight = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme['color.text.light']};
`;

export const SubscriptionPlaceholder = styled.div`
  padding: 30px 22px 15px 19px;
`;

export const StyledMenu = styled(Menu)`
  margin-top: 15px;
  margin-left: 18px;
  width: 219px;
  max-height: 99vh;
  overflow-y: auto;
  scrollbar-width: thin;
  background: ${(props) => props.theme['color.background']};
  ::-webkit-scrollbar {
    width: 8px;
    height : 30px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 6px;
  }
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #888; 
}
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
`;

export const MenuItemTitle = styled.span`
  text-align: left;
  line-height: 25px;
  width:150px;
`;

export const MenuItemTitleDefault = styled(MenuItemTitle)`
  line-height: 30px;
  font-weight:bold;
`;

export const LineBreak = styled.hr`
  background-color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.1).toString()};
  border: none;
  height: 1px ;
  width : 100%;
  padding: 0px;
`;

